export enum JobSearchArea {
  AREA = "area",
  CITY = "city",
  NATIONWIDE = "nationwide",
  HOMEWORK = "homework",
}
